import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronRightBold24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.3848 11.1172V12.8848L8.88477 20.3848L7.11719 18.6172L13.7334 12.001L7.11719 5.38477L8.88477 3.61719L16.3848 11.1172Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronRightBold24);
export { ForwardRef as ReactComponent };
